import {HTMLAttributes} from 'react';

export const BorderedTextSeparator = ({children, ...props}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} className="flex w-full items-center gap-3">
      <Border />
      {children && (
        <>
          <div className="text-center text-sm font-semibold leading-4 text-gray-400">{children}</div>
          <Border />
        </>
      )}
    </div>
  );
};

const Border = () => <div className="h-px grow bg-gray-300" />;
